export function saveTeacher(teacher) {
  return {
    type: "SAVE_TEACHER",
    teacher
  };
}

export function clearTeacher() {
  return {
    type: "CLEAR_TEACHER"
  };
}

export function changeTheme(theme) {
  return {
    type: "CHANGE_THEME",
    theme
  };
}